
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "pay-success",
components: {
XHeader
},
data() {
return {
title: "支付状态",
total:'100'
}
},
methods:{
repay(){
var _this = this;
/*_this.$vux.loading.show({
text: 'Loading'
})
welcomeapi.welcomepost('/NewReports/addInformation',
{
"stuCode":_this.$store.state.stu_num,
"stuName":_this.stuinfo.name,
/!*"stuCode":'1801010122',
"stuName":'皮皮虾',*!/
"weChat":_this.stuinfo.wechat,
"email":_this.stuinfo.email,
"phone":_this.stuinfo.phone,
"dName":_this.stuinfo.dname,
"dRelation":_this.stuinfo.drelate,
"dPhone":_this.stuinfo.dphone,
"mName":_this.stuinfo.mname,
"mRelation":_this.stuinfo.mrelate,
"mPhone":_this.stuinfo.mphone
}
).then(function (response) {
var data = response.data;
console.log(response.data);

if (data.result == true){
_this.$vux.loading.hide()
_this.$router.push({name: 'schoolInformation'});
}else {
_this.$msgbox('温馨提示：',"您的信息不完善");
_this.$vux.loading.hide()
}
})*/
var sort = _this.$route.params.sort;
var stunum = _this.$route.params.stunum;
_this.$router.push({name: 'pay',params:{sort:sort,stunum:stunum}});
},
goback(){
var _this = this;
/*_this.$vux.loading.show({
text: 'Loading'
})
welcomeapi.welcomepost('/NewReports/addInformation',
{
"stuCode":_this.$store.state.stu_num,
"stuName":_this.stuinfo.name,
/!*"stuCode":'1801010122',
"stuName":'皮皮虾',*!/
"weChat":_this.stuinfo.wechat,
"email":_this.stuinfo.email,
"phone":_this.stuinfo.phone,
"dName":_this.stuinfo.dname,
"dRelation":_this.stuinfo.drelate,
"dPhone":_this.stuinfo.dphone,
"mName":_this.stuinfo.mname,
"mRelation":_this.stuinfo.mrelate,
"mPhone":_this.stuinfo.mphone
}
).then(function (response) {
var data = response.data;
console.log(response.data);

if (data.result == true){
_this.$vux.loading.hide()
_this.$router.push({name: 'schoolInformation'});
}else {
_this.$msgbox('温馨提示：',"您的信息不完善");
_this.$vux.loading.hide()
}
})*/
var sort = _this.$route.params.sort;
var stunum = _this.$route.params.stunum;
_this.$router.push({name: 'onlinefee',params:{sort:sort,stunum:stunum}});
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/PayFailed.vue